
import { useNavigate } from "react-router-dom";
import * as PR from "../../../../prime-react/index";
import { DateFormat, pagecount } from "../../../../utils/reuse";
import { useSelector } from "react-redux";

const BetTable = ({ betData, loading, page, paging, last, handlePageChange, sortField, sortOrder, sortHandler, type, groupId }) => {
    const alertPlatformState = useSelector(state => state.alertPlatformFilter.bettingDataFilters);
    const anomaliesPlatformState = useSelector(state => state.alertPlatformFilter.anomalieFilters);

    const navigate = useNavigate();
    const action = (rowData) => {
        const handleViewDetails = (e) => {
            const url = `/bet-details/${rowData.reportID}`;
            if (e && (e.ctrlKey || e.metaKey)) {
                window.open(url, '_blank');
            } else {
                navigate(url, { state: { isVoucherBet: !rowData.betID, type, playerId: rowData.playerID, groupId } });
            }
        };
        return <PR.Button label="View Details" className="view-button" onClick={handleViewDetails} />;
    };
    const reportDateDisplay = (rowData) => {
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                    <p>{DateFormat(rowData.reportDate)}</p>
                    {/* <span>{formatTime(rowData.eventDate)}</span> */}
                </div>
            </div>
        );
    };
    const playerDisplay = (rowData) => {
        const handlePlayerClick = (e) => {
            const url = `/player-analytics/${rowData.playerID}`;
            if (e && (e.ctrlKey || e.metaKey)) {
                window.open(url, '_blank');
            } else {
                navigate(url, { state: { date: type ? anomaliesPlatformState?.date?.date : alertPlatformState?.date?.date } });
            }
        };
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                   <p className="underline cursorPointer" onClick={handlePlayerClick}>{rowData?.playerID}</p>
                </div>
            </div>
        );
    }

    const paginationTemplate = {
        layout: 'CurrentPageReport PrevPageLink NextPageLink',
        CurrentPageReport: (options) => {
            return ( <span className='current-page'>Page {page}</span> )
        },
        PrevPageLink: (options) =>{
            return (<PR.Button className='pagination-buttons'
                        onClick={() => handlePageChange(page-1)}
                        disabled={paging ? page <= 1 ? true : false :true}>Previous</PR.Button>
                    )
        },
        NextPageLink: (options) =>{
            return (<PR.Button disabled={paging ? last ? true : false : true} onClick={() => handlePageChange(page+1)} 
            className='pagination-buttons'>Next</PR.Button>)
        }
    };

    return (
        <PR.DataTable
            value={betData}
            stripedRows
            className="data-table"
            paginator
            paginatorTemplate={paginationTemplate}
            rows={pagecount}
            loading={loading}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={(data) => {sortHandler(data) }}
            >
            <PR.Column body={reportDateDisplay} field="reportDate" header="Date" className="date-column" sortable sortField="reportdate" sortableDisabled={!betData?.length} bodyClassName="date-column"/>
           { type !== 'player' && <PR.Column body={playerDisplay} field="playerID" header="PlayerID" sortable sortField="playerid" sortableDisabled={!betData?.length}/>}
            <PR.Column field="property" header="Property" sortable={!type || type === 'anomalies'} sortField="property" sortableDisabled={!betData?.length} style={{textTransform:'capitalize'}}/>
           { type !== 'anomalies' && <PR.Column field="event" header="Event" />}
            <PR.Column field="sport" header="Sport" />
            { type === 'anomalies' && <PR.Column field="market" header="Market" /> }
            { type === 'anomalies' && <PR.Column field="selection" header="Selection" /> }
            <PR.Column field="stakeFormat" header="Stake" className="price-format-column" sortable  sortField="stake"  sortableDisabled={!betData?.length}/>
            <PR.Column field="netGGRFormat" header="Net GGR" className="price-format-column" sortable   sortField="netggr"  sortableDisabled={!betData?.length} bodyClassName="netGGR-column"/>
            <PR.Column field="status" header="Status" className="status-column" sortable  sortField="status"  sortableDisabled={!betData?.length}/>
            <PR.Column body={action} header="Action" bodyClassName="last-column" sortableDisabled={!betData?.length}/>
        </PR.DataTable>
    )
}
export default BetTable;
